import axios from 'axios'
import axiosRetry from "axios-retry";
import store from '@/store';
import { requestOptions } from '@/helpers/request-options'

const referenceApiClient = axios.create({
})

axiosRetry(referenceApiClient, {
    retries: 3,
    retryDelay: () => 3000,
    retryCondition: () => true,
})

const apiSource = process.env.VUE_APP_API;

export default {
    GetSearch(mfrIds, term, page) {

        var mfrId = "";
        for (var i = 0; i < mfrIds.length; i++) {
            if (mfrId != "")
                mfrId += `,${mfrIds[i]}`;
            else
                mfrId += `${mfrIds[i]}`;
        }

        if (!term)
            term = "";

        if (!page)
            page = 1;

        return referenceApiClient(
            requestOptions.get(
                apiSource + `/api/v1/${store.state.instance}/Reference/Search?mfrIds=${mfrId}&term=${term}&page=${page}`
            )
        )
    },
    GetDetail(uuid, page) {
        return referenceApiClient(
            requestOptions.get(
                apiSource + `/api/v1/${store.state.instance}/Reference/Detail?uuid=${uuid}&page=${page}`
            )
        )
    },
    Download(uuid) {
        return referenceApiClient(
            requestOptions.get(
                apiSource + `/api/v1/${store.state.instance}/Reference/Download?uuid=${uuid}`
            )
        )
    },
}